function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function apiRequestPattern(apiURL: string): RegExp {
  return new RegExp(`^${escapeRegExp(apiURL)}/(eazi/api|customerdata/configurations|customerdata/portal)/`);
}
